<template>
  <div class="comment">
    <div class="box-user">
      <div class="box-user-img">
        <ImageWrapper v-if="comment._embedded.User.idPicture" :file="comment._embedded.User.idPicture"></ImageWrapper>
        <img v-else src="../../assets/images/avatar-placeholder.png">
      </div>
      <div>
        <span class="box-user-name">{{ comment._embedded.User.name }}</span>
        <span class="box-user-email"> {{ comment._embedded.User.email }}</span>
      </div>
    </div>
    <div class="comment-content">{{comment.commentText | decodeUnicode}}
    </div>
    <span class="label" v-if="comment.attachments && comment.attachments.length">Attachments</span>
    <div class="attachment-box" v-for="(attachment, i) in comment.attachments" :key="i" v-bind:class="attachmentClassDirectory(attachment.file_type)">
      <div>
        <span class="attachment-box-name">{{attachment.file_name}}</span>
        <span class="attachment-box-size">{{attachment.file_size}}</span>
      </div>
      <a class="attachment-box-show" target="_blank" :href="attachment.url"></a>
    </div>

    <Gallery v-if="comment.idFile" :gallery="[{idFile: comment.idFile}]" />

    <div class="comment-bottom">
      <span class="box-date">{{comment.createdAt | timeSince(comment.createdAtTimezone)}}</span>
      <div>
        <button class="link-icon" @click="like">
          <i class="icon-vote-empty" v-if="!likedByCurrentUser"></i>
          <i class="icon-vote-filled" v-if="likedByCurrentUser"></i>
          <span>
            Like ({{comment._embedded.UserContentReaction.length}})
          </span>
        </button>
        <button class="link-icon" @click="showAnswerForm = true"><i class="icon-comment"></i> <span>Answer</span></button>
<!--        <button class="link-icon" @click="report"><i class="icon-report"></i> <span>Report</span></button>-->
      </div>
    </div>

    <div class="comment-reply" v-if="showAnswerForm">
      <AddComment :replayTo="comment" @add="addResponse" @cancel="showAnswerForm = false"></AddComment>
    </div>

    <div class="loadmore comment-answers-wrapper">
      <CommentAnswer v-for="(replay, i) in comment._embedded.Comments" :key="i" :replay="replay"></CommentAnswer>
    </div>
  </div>
</template>

<script>
import CommentAnswer from './CommentAnswer'
import AddComment from "./AddComment";
import Gallery from "@/components/general/Gallery";
import api from "@/api/ideas";
import ImageWrapper from "@/components/general/ImageWrapper";
export default {
  name: "CommentItem",
  components: {ImageWrapper, CommentAnswer, AddComment, Gallery},
  props: ['comment'],
  data() {
    return {
      showAnswerForm: false
    }
  },
  computed: {
    likedByCurrentUser() {
      return this.comment._embedded.UserContentReaction.some(item => {
        return item.idUser === this.$store.getters.user.idUser
      })
    },
  },
  methods: {
    toggleVote () {
      this.voted = false;
      let data = {
        idUser: this.$store.getters.user.idUser,
        idContent: this.idea.idContent,
        type: 'VOTE',
        deleteReaction: this.userVoted ? 1 : null
      }
      api.addReaction(data, response => {
        this.voted = false;
        if(response.idUser) {
          this.voted = true;
        }
        this.getIdea();
      })
    },
    like() {
      let data = {
        idUser: this.$store.getters.user.idUser,
        idContent: this.comment.idContentSelf,
        type: 'LIKE',
        deleteReaction: this.likedByCurrentUser ? 1 : null
      }
      api.addReaction(data, response => {
        this.voted = false;
        if(response.idUser) {
          this.voted = true;
        }
        this.$emit('refresh')
      })
    },
    addResponse() {
      this.$emit('refresh')
    },
    attachmentClassDirectory(type) {
      switch (type) {
        case 'image/jpeg':
        case 'image':
        case 'image/png':
        case 'image/gif':
          return 'attachment-box--pic'
        case 'application/pdf':
        case 'pdf':
          return 'attachment-box--pdf'
        case 'document':
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessing':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'attachment-box--word'
      }
      return 'attachment-box--default'
    },
    report() {
      alert("Reported!!!")
    }
  }
}
</script>

<style scoped>

</style>
